import { render, staticRenderFns } from "./VehicleDocumentsAlertModal.vue?vue&type=template&id=6bb840d6&scoped=true&"
import script from "./VehicleDocumentsAlertModal.vue?vue&type=script&lang=js&"
export * from "./VehicleDocumentsAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDocumentsAlertModal.vue?vue&type=style&index=0&id=6bb840d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb840d6",
  null
  
)

export default component.exports